import { render, staticRenderFns } from "./LeaveRequests.vue?vue&type=template&id=31656b70&scoped=true&"
import script from "./LeaveRequests.vue?vue&type=script&lang=js&"
export * from "./LeaveRequests.vue?vue&type=script&lang=js&"
import style0 from "./LeaveRequests.vue?vue&type=style&index=0&id=31656b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31656b70",
  null
  
)

export default component.exports